import React from 'react'
import { FooterContainer } from './styles'
import VersionIndicator from '../VersionIndicator'

export default function Footer () {
  return (
    <FooterContainer>
      <VersionIndicator />
    </FooterContainer>
  )
}
